import React from "react";
// import styled from "styled-components";
// import "../App.css";
const Stats = () => {
  return (
    // streak 
    <div name="calender"
    className="bg-gradient-to-b from-black  to-teal-900 w-full h-screen">
        <div className="max-w-screen-lg mx-auto p-4 flex flex-col justify-center w-full h-full text-white">
            <div>
            <p className="text-4xl font-bold border-b-4 border-gray-500 p-2 inline">
            Statistics
          </p>
            </div>
            <div style={{margin:"auto"}}>
      {/* <div style={{ width: "40%", margin: "auto" }}>
        <a href="https://github.com/martina024">
          <img
            align="center"
            src="https://github-readme-streak-stats.herokuapp.com?user=martina024"
          />
        </a>
      </div> */}
 
      <div
        style={{
          width: "100%",
          height: "300px",
          display: "flex",
          margin: "auto",
          gap:"20px"
            
        }}
      >
         <a href="https://github.com/martina024">
          <img
            align="center"
            src="https://github-readme-streak-stats.herokuapp.com?user=martina024"
          />
        </a>

        {/* <a href="https://github.com/saurabh0413">  
          <img
            align="center"
            src="https://github-readme-stats.vercel.app/api/top-langs/?username=martina024"  //launguages
          />
        </a> */}
        <a href="https://github.com/martina024">
          <img
            align="center"
           
            src="https://github-readme-stats.vercel.app/api?username=martina024&count_private=true&show_icons=true" //stats
          />
        </a>
      </div>
    </div>
        </div>
        
    </div>
   
  );
};

export default Stats;